import axios from 'axios';
import { API_URL, API_URL_PDF } from '../config/constants';
import BaseService from './baseService';
const rota = 'catalogos';
const service = new BaseService(rota);

const getList = async (body, skip, limit) => {
    const res = await service.getList(body, skip, limit);
    return res;
}

const getById = async (id) => {
    const res = await service.getById(id);
    return res;
}

const reorder = async (body) => {
    const res = await service.reorder(body);
    return res;
}

const upsert = async (body, id) => {
    const res = await service.upsert(body, id);
    return res;
}

const convertPdfToImage = async url => {
    const res = await axios.post(`${API_URL_PDF}`,{url});
    return res.data
}


const uploadFile = async file => {
    const body = {
        fileData: file,
        fileName: Date.now() + ".jpg"
    }
    const res = await axios.post(`${API_URL}catalogos/upload`, body);
    if(!res.data.erro){
        return res.data.fileUrl;
    } else {
        return false;
    }
}

const get = async (rotaAdd) => {
    const res = await service.get(`${rota}/${rotaAdd}`);
    return res;
}

export default { getList, getById, upsert, uploadFile, reorder, convertPdfToImage, get };
